import styled from 'styled-components'

export const CopyContainer = styled.div`
  margin-top: 4px;
  margin-bottom: 16px;
`

export const WeightInputContainer = styled.div`
  display: flex;
  width: 232px;
`

export const InnerField = styled.div`
  margin-left: 36px;
`

export const ShippingSubtitle = styled.div`
  & > * + * {
    margin-left: 8px;
  }
`

export const TaxFieldsWrapper = styled.div`
  margin-top: 8px;
`
